import { render, staticRenderFns } from "./TransactionChartModal.vue?vue&type=template&id=56b7979c&scoped=true"
import script from "./TransactionChartModal.vue?vue&type=script&lang=js"
export * from "./TransactionChartModal.vue?vue&type=script&lang=js"
import style0 from "./TransactionChartModal.vue?vue&type=style&index=0&id=56b7979c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b7979c",
  null
  
)

export default component.exports